module.exports = __webpack_public_path__ + "static/media/table-tennis.fc7878a0.svg";